const toAuto =  (element, duration = 1000) => jQuery(($) => {
    element.animate({
        height: element.get(0).scrollHeight
    }, duration, function(){
       element.height('');
    });
});

const fromAuto =  (element, duration = 1000, toHeight = 0) => jQuery(($) => {
    element.height(element.height());
    element.animate({
        height: 0
    }, duration);
});

export { toAuto, fromAuto };
